/** Unavailable lookup labels are evidence gaps, never mapped FEMA zones.
 * Zone D is deliberately absent: it is a real FEMA zone classification. */
const UNAVAILABLE_FLOOD_ZONES = new Set([
  '', 'UNKNOWN', 'UNAVAILABLE', 'NOT AVAILABLE', 'DATA NOT AVAILABLE', 'N/A', 'NA', 'NOT KNOWN',
]);

export function isUnavailableFloodZone(value: unknown): boolean {
  return typeof value === 'string' && UNAVAILABLE_FLOOD_ZONES.has(value.trim().toUpperCase());
}

export function isUnavailableFloodPrecedence(
  violation: { fact: string; tier1Value: string | number } | null | undefined,
): boolean {
  return violation?.fact === 'floodZone' && isUnavailableFloodZone(violation.tier1Value);
}

export function unavailableFloodZoneAction(reportedZone: string | number, provider: string): string {
  return `${provider} does not establish a mapped flood zone in the current site evidence. Verify the report's zone ${reportedZone} against its cited parcel-scoped map; do not replace it with an unavailable lookup label.`;
}
